import { brDateTime } from 'oderon-commons/src/formatters'
import { preProcessSpec } from 'oderon-commons/src/tables'

export const defCodes = ['timestamp', 'orgCode', 'login', 'action', 'label']

export const fullSpec = preProcessSpec({
  defaultSortable: false,
  defCodes,
  idProp: '_id',
  columns: [
    { t: 'ID|', d: '_id', selectable: true },
    {
      w: 200,
      t: 'Timestamp|',
      d: 'timestamp',
      f: brDateTime
    },
    { w: 200, t: 'Org', d: 'orgCode' },
    { w: 200, t: '|Login', d: 'login' },
    { w: 150, t: 'Ação|', d: 'action' },
    { t: 'ObjectType', d: 'subjectType', selectable: true },
    { t: 'ObjectId', d: 'subjectId', selectable: true },
    { t: 'Comentários', d: 'comments', selectable: true },
    { t: 'Label', d: 'label' },
    {
      t: 'Objeto',
      code: 'subjectLine',
      d: (r) => `${r.subjectType} #${r.subjectId}`,
      selectable: true
    }
  ]
})
